import { useTranslations } from 'next-intl';

import { globalConst, slugify } from 'modules/global';

import { BlockTestInfoSection, Description, SubjectCard } from 'components';

import { useBlocks } from '../hooks';

export const Main = () => {
  const t = useTranslations();
  const { block } = useBlocks();

  return (
    <div className="mt-6">
      <div className="space-y-6">
        <h1 className="text-center text-2xl font-semibold uppercase">{t('home.banner.DTMtest')}</h1>
        <BlockTestInfoSection title={t('dtm_test_haqida_toliq_malumot')} href="#info" />
      </div>
      <div className="mb-13 mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
        {block?.blocks?.map(block => (
          <SubjectCard
            color={block?.color}
            url={`${globalConst.pageNames.DTM}/${block?.id}-${slugify(block?.name || '')}`}
            key={block?.id}
            title={block?.name}
            testCount={block?.collections_count}
          />
        ))}
      </div>
      <Description description={block?.description} text={t('dtm_test_haqida_toliq_malumot')} />
    </div>
  );
};
